var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCompute = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1276_6140",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1276_6140",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAWqADAAQAAAABAAAAWgAAAABJfIu3AAADIUlEQVR4Ae2dP04zMRDFNwhKGjgFV4Fz0NAg6DgBHYiGhnPAVTgFNJQUoEVxFCXet+Px82SXvEifNl/mr39+8lgQicX90/NPp1dzAgfNK6jAH4HDxOHu+mqR3uvJI5BODCmaxxRmEmiIh2dcHR3rKT9uOg3IdSCF708fu61jWIouhOh1F2gvucI4gS4E5nUXaC+5wjiBLgTmdRdoL7nCOIEuBOZ1F2gvucI4gS4E5nUXaC+5wjiBLgTmdQ8FffLw0/X/cq8p2XL91X4WCrq22TnHC3TQ7gm0QAcRCCojRQt0EIGgMtlfZbFrH1++dkdn56u0Q1e83mEXtu/3t+7r5WLVX4s3IUfHOuQWi6jNGdEfTdFIiQnE5+3W7yyTaWfP1Hd65hph9B2i6Fzz+/YZTdFo15FapgIc9c/oUYpmUDTkEGgDJIaLQDMoGnLQzmhDrUGXzXv2oKPTEHFPHmuNBrpm4LW+x1ryo/4Zg5IGemxHLXbGgjbrIICbvi3/TwONIE1lsQgk6h/FWW0ahlZSlX4CXQnQGi7QVlKVfgJdCdAaThuGcxh4CArqnzEopWhEn2ijKRrtOlILcS1VqVD/VYmXwVI0g6Ihh0AbIDFcBJpB0ZBDoA2QGC60YTiHgYeAof4Zg1KKRvSJNpqi0a4jtRDXUpUK9V+VeBksRTMoGnIItAESw0WgGRQNOQTaAInhQhuGcxh4CBjqnzEoaaDRIqw2tFhrjqn60UCjXR8D2H/vwvKVAC/EPv/YC/U/Fmux00Bbig35tP4S+FDdyM81DINoC7RABxEIKkM7o8cGXtB63GVQ/4xBqaPDvTVlgTRFo11PaknPshZjvFH/jA5CFG25xzIW480R0R9N0WiR6Z6cFJ1Tz5RsaC1eW4iivc39pziBDtpNgRboIAJBZaRogQ4iEFQm5HqX1pK71k3RlnpiPnV0MGmCXAIN4DBNAs2kCXIJNIDDNAk0kybIJdAADtMk0EyaIJdAAzhMk0AzaYJcAg3gME0CzaQJcgk0gMM0ZX+olPt7fMyi+5hLig7adYEOAr1If+U3qN7elpGig7b+F9RhoLhxzyf2AAAAAElFTkSuQmCC"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCompute);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/compute.d3da535101f2a3a1074ef1b0781b2b59.svg";